import React from "react";
import { useAuth } from "@/context/AuthContext";
import { LOGIN } from "@/constants/testIds";
import { Button } from "@/components/ui/button";
import { Navigate, useNavigate } from "react-router-dom";
import { Dumbbell, BrainCircuit } from "lucide-react";

export default function Login() {
    const { user, setRole } = useAuth();
    const navigate = useNavigate();

    const startGoogle = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/dashboard";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
            redirectUrl
        )}`;
    };

    // If authenticated but no role, show role picker
    if (user && user.role === "unassigned") {
        const pickRole = async (role) => {
            await setRole(role);
            navigate(role === "coach" ? "/dashboard" : "/");
        };
        return (
            <div className="mx-auto flex min-h-[80vh] max-w-[800px] flex-col items-center justify-center px-6">
                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">
                    Dernière étape
                </div>
                <h1 className="mt-2 text-center font-display text-5xl uppercase leading-none tracking-tight text-white sm:text-6xl">
                    Choisis ta voie
                </h1>
                <p className="mt-4 max-w-md text-center text-sm uppercase tracking-widest text-neutral-400">
                    Tu pourras utiliser l&apos;autre côté à tout moment — ceci configure
                    juste le bon espace.
                </p>
                <div className="mt-10 grid w-full grid-cols-1 gap-4 sm:grid-cols-2">
                    <button
                        data-testid={LOGIN.roleClient}
                        onClick={() => pickRole("client")}
                        className="group flex flex-col items-start gap-3 border border-white/10 bg-[#121212] p-8 text-left transition-colors hover:border-[#FF2E2E]"
                    >
                        <Dumbbell className="h-7 w-7 text-[#FF2E2E]" />
                        <div className="font-display text-3xl uppercase tracking-tight text-white">
                            Je cherche un coach
                        </div>
                        <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-400">
                            Parcourir l&apos;annuaire · réserver des séances découverte
                        </div>
                    </button>
                    <button
                        data-testid={LOGIN.roleCoach}
                        onClick={() => pickRole("coach")}
                        className="group flex flex-col items-start gap-3 border border-white/10 bg-[#121212] p-8 text-left transition-colors hover:border-[#FF2E2E]"
                    >
                        <BrainCircuit className="h-7 w-7 text-[#FF2E2E]" />
                        <div className="font-display text-3xl uppercase tracking-tight text-white">
                            Je suis coach
                        </div>
                        <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-400">
                            Créer un profil · suivre les objectifs · gagner du mérite
                        </div>
                    </button>
                </div>
            </div>
        );
    }

    if (user) return <Navigate to="/" replace />;

    return (
        <div className="mx-auto flex min-h-[80vh] max-w-[560px] flex-col items-center justify-center px-6">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">
                Connexion sécurisée
            </div>
            <h1 className="mt-2 text-center font-display text-6xl uppercase leading-none tracking-tight text-white">
                Entrer dans EarnIt
            </h1>
            <p className="mt-4 max-w-sm text-center text-sm uppercase tracking-widest text-neutral-400">
                Pas de pseudo. Pas de compteur d&apos;abonnés. Juste toi et le travail.
            </p>
            <Button
                data-testid={LOGIN.googleBtn}
                onClick={startGoogle}
                className="mt-10 h-14 w-full rounded-none bg-[#FF2E2E] font-display text-xl uppercase tracking-tight hover:bg-[#D61F1F]"
            >
                Continuer avec Google
            </Button>
            <div className="mt-8 border border-dashed border-white/10 p-4 text-center text-[10px] uppercase tracking-[0.3em] text-neutral-600">
                Propulsé par l&apos;OAuth géré par Emergent
            </div>
        </div>
    );
}
